export default __webpack_public_path__ + "static/arweave-b379da426d6bc1c380e2548e2b6ebf40.svg";